export default "__VITE_ASSET__CwdXolKo__"